import React from "react";
import { PetDataFormat } from "store/formTemplate/formTemplateTypes";
import { TenantPetsData, TenantPetsSupportDocuments } from "store/tenant/types";
import Icon from "../../components/UI/Icon/Icon";
import InputField from "../../components/UI/InputField";

interface SupportDocumentProps {
  /**
   * The support document item containing details about the attachment.
   */
  item: TenantPetsSupportDocuments;
  petData?: TenantPetsData | PetDataFormat;
}

const SupportDocument: React.FC<SupportDocumentProps> = ({ item, petData }) => {

  let description = item.description_of_attachment
  

  return (
    <div className="d-flex flex-column gap-10px border-1px border border-grey-3 radius-5px p-10px">
      
      <div className="d-flex gap-20px align-items-center justify-content-between justify-content-md-start">
        <div className="d-flex gap-8px align-items-center">
          <Icon name="download" className="min-w-24px" />
          <div className="fs-16px fw-bold text-black d-flex gap-2px align-items-center">
            <div className="text-truncate max-w-150px max-w-md-full">
              <a href={item?.signed_url} target="_blank" className="text-black" rel="noreferrer">{item.file_name}</a>
            </div>{" "}
            <div className="text-nowrap text-decoration-underline">
              <a href={item?.signed_url} target="_blank" className="text-black" rel="noreferrer">{" "}({item.file_size_formatted})</a>
            </div>
          </div>
        </div>
      </div>

      <div className={`${description ? '' : 'd-none'}`}>
        <InputField
            key={item.id}
            id={`desc-${item.id}`}
            name={`${petData?.pet_type}.upload.${petData?.pet_number}`}
            placeholder="Description of attachment, if applicable"
            variant="editable"
            as="input" 
            onChange={() => {}}           
            defaultValue={description ? description : ''}
            disabled={true}
        />
       </div>

    </div>
  );
};

export default SupportDocument;
